// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalConfirm_wrapper__CxUiw","antWrapper":"ModalConfirm_antWrapper__Ywe15","infoWrapper":"ModalConfirm_infoWrapper__GPBYk"};